import {post} from '@/utils/request';
import {erpserver,erpplatserver,oaserver,sse_url} from '@/utils/baseUrl';

//wanjie
export async function over(params) {
    return post(erpserver+'/sellinvoice/over',params,true)
}
//通知
export async function sendMsg(params) {
    return post(erpserver+'/sellinvoice/sendMsg',params,true)
}
//save
export async function saveGlSq(params) {
    return post(erpserver+'/sellinvoice/saveGlSq',params,true)
}
//查询列表接口
export async function listBeforeInvoice(params) {
    return post(erpserver+'/sellinvoice/listBeforeInvoice',params,true)
}
//查询列表接口
export async function listGlSq(params) {
    return post(erpserver+'/sellinvoice/listGlSq',params,true)
}
//上传发票池
export async function saveToPool(params) {
    return post(erpserver+'/purchaseinvoice/saveToPool', params, true);
}
//发票类型
export async function fplx(params) {
    return post(erpserver+'/purchaseinvoice/fplx', params, true);
}
//上传图片-new
export async function uploadInvoice(params) {
    return post(erpplatserver+'/system/uploadInvoice',params,false);
}

//列表
export async function getKhlistWithNoRights(params) {
    return post(erpserver+'/currency/getKhlistWithNoRights', params, true);
}
//公司
export async function getCompanyList(params) {
    return post(erpserver+'/currency/getCompanyList', params, true);
}
//汇率
export async function getbzlist(params) {
    return post(erpserver+'/currency/getbzlist', params, true);
}

//列表
export async function withInvoiceServer(params) {
    return post(erpserver+'/invoiceInterface/withInvoiceServer', params, true);
}